import { render, staticRenderFns } from "./Step7.vue?vue&type=template&id=10e1bb88&scoped=true&lang=pug"
import script from "./Step7.vue?vue&type=script&lang=js"
export * from "./Step7.vue?vue&type=script&lang=js"
import style0 from "./Step7.vue?vue&type=style&index=0&id=10e1bb88&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e1bb88",
  null
  
)

export default component.exports